import { render } from "./DependenciasMapReq.vue?vue&type=template&id=f066026c&scoped=true"
import script from "./DependenciasMapReq.vue?vue&type=script&lang=js"
export * from "./DependenciasMapReq.vue?vue&type=script&lang=js"

import "./DependenciasMapReq.vue?vue&type=style&index=0&id=f066026c&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f066026c"]])

export default __exports__